import { Link } from "react-router-dom";
import { ArrowUpRight, Plus, Home, MapPin, CalendarCheck } from "lucide-react";
import { SectionHeading } from "./Section";
import { Stagger, StaggerItem, Reveal } from "./Reveal";

export const ServiceList = ({ overline, title, subtitle, services, ctaLabel, accent = "teal" }) => (
  <section className="py-24 md:py-32 bg-white" data-testid="service-list">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading overline={overline} title={title} subtitle={subtitle} />

      <Stagger className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((s, i) => (
          <StaggerItem key={s.name}>
            {s.featured ? (
              <div
                data-testid={`service-item-${s.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group relative h-full overflow-hidden rounded-3xl bg-dash-ink p-7 transition-all duration-400 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_rgb(10,37,64,0.25)]"
              >
                <div className="grain" />
                <div className="relative flex items-start justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-dash-teal text-white">
                    <Home className="h-5 w-5" />
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-dash-gold/15 border border-dash-gold/30 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-dash-gold">
                    <MapPin className="h-3 w-3" /> Belpahar &amp; Jharsuguda
                  </span>
                </div>
                <h3 className="relative mt-4 font-display text-xl font-bold text-white">{s.name}</h3>
                <p className="relative mt-2.5 text-sm leading-relaxed text-white/70">{s.desc}</p>
                <Link
                  to="/contact?service=Home%20Visit%20Physiotherapy"
                  data-testid="featured-book-home-visit"
                  className="relative mt-5 inline-flex items-center gap-2 rounded-full bg-dash-teal px-5 py-2.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-white hover:text-dash-ink"
                >
                  <CalendarCheck className="h-4 w-4" /> Book Home Visit
                </Link>
                <div className="absolute bottom-0 left-0 h-1 w-full bg-dash-teal" />
              </div>
            ) : (
            <div
              data-testid={`service-item-${s.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group relative h-full overflow-hidden rounded-3xl border border-dash-line bg-dash-bg p-7 transition-all duration-400 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_rgb(10,37,64,0.10)] hover:border-transparent"
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-3xl font-bold text-dash-teal/20 group-hover:text-dash-teal/40 transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className={`flex h-9 w-9 items-center justify-center rounded-full ${accent === "teal" ? "bg-dash-teal/10 text-dash-teal" : "bg-dash-indigo/10 text-dash-indigo"} transition-transform duration-400 group-hover:rotate-90`}>
                  <Plus className="h-4 w-4" />
                </span>
              </div>
              <h3 className="mt-4 font-display text-xl font-bold text-dash-ink">{s.name}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-dash-muted">{s.desc}</p>
              <div className={`absolute bottom-0 left-0 h-1 w-0 group-hover:w-full transition-all duration-500 ${accent === "teal" ? "bg-dash-teal" : "bg-dash-indigo"}`} />
            </div>
            )}
          </StaggerItem>
        ))}
      </Stagger>

      <Reveal delay={0.1}>
        <div className="mt-14 flex justify-center">
          <Link
            to="/contact"
            data-testid="service-list-cta"
            className={`group inline-flex items-center gap-2 rounded-full px-8 py-4 font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 ${accent === "teal" ? "bg-dash-teal hover:bg-dash-ink" : "bg-dash-indigo hover:bg-dash-ink"}`}
          >
            {ctaLabel}
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
